import { get, post } from "../utility/fetch-util";

/**
 * Get the driver for the signed in user
 */
export const getDriver = async (progress) => {
    return get('/api/drivers/driver', null, progress);
}

/**
 * Update the driver for the signed in user
 */
export const saveDriver = async (driver, progress) => {
    return post('/api/drivers/driver', null, driver, progress);
}

export const getLicenceCategories = async (progress) => {
    return get('/api/drivers/driver/licence-categories', null, progress);
}

/**
 * Update the driver licence for the signed in user
 */
export const saveDriverLicence = async (driver, licence, progress) => {
    return post('/api/drivers/driver/driver-licence/save', null, licence, progress);
}

/**
 * Get Additional Links for signed in user
 */

export const getAdditionalLinks = async (progress) => {
    return get('/api/drivers/driver/additional', null, progress);
}

/**
 * Get Defined Content
 */

export const getDefinedContent = async (contentSetId, progress) => {
    return get('/api/drivers/driver/content/' + contentSetId, null, progress);
}
